import axios from "axios";
import localforage from "localforage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const queueStore = localforage.createInstance({ name: "pintaflow", storeName: "mutation_queue" });
const cacheStore = localforage.createInstance({ name: "pintaflow", storeName: "get_cache" });

export const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("session_token");
  if (token && !cfg.headers.Authorization) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// --- offline helpers ---
async function cacheKey(method, url, params) {
  return `${method}:${url}:${JSON.stringify(params || {})}`;
}

async function readCache(method, url, params) {
  const k = await cacheKey(method, url, params);
  return cacheStore.getItem(k);
}

async function writeCache(method, url, params, data) {
  const k = await cacheKey(method, url, params);
  await cacheStore.setItem(k, data);
}

export async function apiGet(path, params) {
  try {
    const r = await client.get(path, { params });
    await writeCache("GET", path, params, r.data);
    return r.data;
  } catch (err) {
    if (!navigator.onLine || err.code === "ERR_NETWORK") {
      const cached = await readCache("GET", path, params);
      if (cached) return cached;
    }
    throw err;
  }
}

export async function apiMutate(method, path, body) {
  if (!navigator.onLine) {
    const id = `pending_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    await queueStore.setItem(id, { method, path, body, ts: Date.now() });
    return { pending: true, _localId: id, ...body };
  }
  const r = await client.request({ url: path, method, data: body });
  return r.data;
}

export async function flushQueue() {
  const keys = await queueStore.keys();
  for (const k of keys) {
    const item = await queueStore.getItem(k);
    if (!item) continue;
    try {
      await client.request({ url: item.path, method: item.method, data: item.body });
      await queueStore.removeItem(k);
    } catch (e) {
      // keep in queue, retry next time
      break;
    }
  }
}

window.addEventListener("online", () => {
  flushQueue();
});

export const PLATFORMS = [
  { id: "youtube_long", label: "YouTube Long", short: "YT" },
  { id: "shorts", label: "Shorts", short: "Shorts" },
  { id: "reels", label: "Reels", short: "Reels" },
  { id: "tweet", label: "X / Tweet", short: "X" },
  { id: "blog", label: "Blog", short: "Blog" },
];

export const STAGES = [
  { id: "idea", label: "Idea", color: "var(--status-idea)" },
  { id: "research", label: "Research", color: "var(--status-research)" },
  { id: "script", label: "Script", color: "var(--status-script)" },
  { id: "create", label: "Create", color: "var(--status-create)" },
  { id: "schedule", label: "Schedule", color: "var(--status-schedule)" },
  { id: "published", label: "Published", color: "var(--status-published)" },
];
